import { useMemo } from 'react';

export function useParsedNewState(newStateStr) {
  return useMemo(() => {
    let state;
    try {
      state = typeof newStateStr === 'string' ? JSON.parse(newStateStr) : newStateStr;
    } catch {
      return { error: true, raw: newStateStr, filteredTrades: [] };
    }
    if (!Array.isArray(state)) return { error: false, filteredTrades: [] };
    const filteredTrades = state.filter(trade =>
      (trade.assigned_included_scopes && trade.assigned_included_scopes.length > 0) ||
      (trade.assigned_additional_scopes && trade.assigned_additional_scopes.length > 0)
    );
    return { error: false, filteredTrades, raw: newStateStr };
  }, [newStateStr]);
} 